import { useState } from "react";
import { Form, Button, InputGroup, Spinner } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import { LoginFormType } from "../types/login";
import { LoginSchema } from "../validation/login.schema";
import { useLogin } from "../hooks/useAuth";
import { SiteLogo } from "src/assets";
import { AnalyticGraph } from "src/assets";

export default function AnalyticsLogin() {
  const [showPassword, setShowPassword] = useState(false);

  const { mutate: login, isPending } = useLogin();

  const { control, handleSubmit } = useForm<LoginFormType>({
    mode: "onBlur",
    resolver: zodResolver(LoginSchema),
    defaultValues: {
      email: "",
      password: "",
    },
  });

  return (
    <>
      <div className="login-page d-flex flex-column flex-fill">
        <div className="container p-5 py-md-5 d-flex flex-column flex-fill p-0">
          <div className="card rounded-4 row">
            <div className="col-form p-4 p-md-5 col-lg-5 col-md-6 col-12">
              <div className="logo mb-2 mb-md-5">
                <img src={SiteLogo} alt="Site logo" />
                <p className="mt-3">
                  Patient Assistance Programs for Faster Therapy Onboarding
                </p>
              </div>
              <div className="mb-2 mb-md-5">
                <h3 className="mb-2 text-tengerine">Welcome back!</h3>
                <p className="mb-2">Please login with your credentials</p>
              </div>

              <Form onSubmit={handleSubmit((values) => login(values))}>
                <Controller
                    name="email"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                        <Form.Group className="mb-3" controlId="formEmail">
                          <Form.Label className="float-start mb-2">
                            Email *
                          </Form.Label>
                          <Form.Control
                              {...field}
                              type="email"
                              placeholder="Email"
                              isInvalid={!!(error && error.message)}
                          />
                          {error && error.message && (
                              <div className="text-danger small mt-1">
                                {error.message}
                              </div>
                          )}
                        </Form.Group>
                    )}
                />

                <Controller
                    name="password"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                        <Form.Group className="mb-3" controlId="formPassword">
                          <Form.Label className="float-start mb-2">
                            Password *
                          </Form.Label>
                          <InputGroup>
                            <Form.Control
                                type={showPassword ? "text" : "password"}
                                placeholder="Password"
                                {...field}
                                isInvalid={!!(error && error.message)}
                                minLength={8}
                                //   maxLength={50}
                            />
                            <InputGroup.Text
                                onClick={() => setShowPassword(!showPassword)}
                                style={{
                                  cursor: "pointer",
                                  backgroundColor: "white",
                                }}
                            >
                              {showPassword ? (
                                  <i className="bi bi-eye"></i>
                              ) : (
                                  <i className="bi bi-eye-slash"></i>
                              )}
                            </InputGroup.Text>
                          </InputGroup>
                          {error && error.message && (
                              <div className="text-danger small mt-1">
                                {error.message}
                              </div>
                          )}
                        </Form.Group>
                    )}
                />

                <div className="my-4">
                  <Button
                      className="w-100 d-flex justify-content-center align-items-center gap-2"
                      variant="primary"
                      type="submit"
                      disabled={isPending}
                  >
                    {isPending && (
                        <Spinner
                            className="me-1"
                            animation="border"
                            size="sm"
                            role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    )}
                    Log In
                    <i className="bi bi-arrow-right fs-5 align-middle"></i>
                  </Button>
                </div>
              </Form>
              <p className="small text-center text-primary m-0">
                © 2026 Elusa Health All rights reserved
              </p>
            </div>
            <div className="col-bg d-none d-md-flex flex-column text-cream col-lg-7 col-md-6">
              <img src={AnalyticGraph} className="d-block mb-5" alt="..." />
              <h1>
                Getting life saving therapies to patients should be seamless.
              </h1>
              <p className="fs-5">
                Our technology makes the path from diagnoses to on-therapy
                easier and faster.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/*<Container*/}
      {/*  fluid*/}
      {/*  className="vh-100 d-flex align-items-center justify-content-center bg-light"*/}
      {/*>*/}
      {/*  <Row className="w-100 justify-content-center">*/}
      {/*    <Col xs={12} sm={10} md={8} lg={6} xl={4}>*/}
      {/*      <Card className="shadow-lg border-0">*/}
      {/*        <Card.Body className="p-5">*/}
      {/*          <div className="text-center mb-4">*/}
      {/*            <h2 className="fw-bold text-primary">Analytics Platform</h2>*/}
      {/*            <p className="text-muted">Sign in to your account</p>*/}
      {/*          </div>*/}

      {/*          <Form onSubmit={handleSubmit((values) => login(values))}>*/}
      {/*            <Controller*/}
      {/*              name="email"*/}
      {/*              control={control}*/}
      {/*              render={({ field, fieldState: { error } }) => (*/}
      {/*                <Form.Group className="mb-3" controlId="formEmail">*/}
      {/*                  <Form.Label className="float-start">Email *</Form.Label>*/}
      {/*                  <Form.Control*/}
      {/*                    {...field}*/}
      {/*                    type="email"*/}
      {/*                    placeholder="Email"*/}
      {/*                    isInvalid={!!(error && error.message)}*/}
      {/*                  />*/}
      {/*                  {error && error.message && (*/}
      {/*                    <div className="text-danger small mt-1">*/}
      {/*                      {error.message}*/}
      {/*                    </div>*/}
      {/*                  )}*/}
      {/*                </Form.Group>*/}
      {/*              )}*/}
      {/*            />*/}

      {/*            <Controller*/}
      {/*              name="password"*/}
      {/*              control={control}*/}
      {/*              render={({ field, fieldState: { error } }) => (*/}
      {/*                <Form.Group className="mb-3" controlId="formPassword">*/}
      {/*                  <Form.Label className="float-start">*/}
      {/*                    Password **/}
      {/*                  </Form.Label>*/}
      {/*                  <InputGroup>*/}
      {/*                    <Form.Control*/}
      {/*                      type={showPassword ? "text" : "password"}*/}
      {/*                      placeholder="Password"*/}
      {/*                      {...field}*/}
      {/*                      isInvalid={!!(error && error.message)}*/}
      {/*                      minLength={8}*/}
      {/*                      maxLength={50}*/}
      {/*                    />*/}
      {/*                    <InputGroup.Text*/}
      {/*                      onClick={() => setShowPassword(!showPassword)}*/}
      {/*                      style={{*/}
      {/*                        cursor: "pointer",*/}
      {/*                        backgroundColor: "white",*/}
      {/*                      }}*/}
      {/*                    >*/}
      {/*                      {showPassword ? (*/}
      {/*                        <i className="bi bi-eye"></i>*/}
      {/*                      ) : (*/}
      {/*                        <i className="bi bi-eye-slash"></i>*/}
      {/*                      )}*/}
      {/*                    </InputGroup.Text>*/}
      {/*                  </InputGroup>*/}
      {/*                  {error && error.message && (*/}
      {/*                    <div className="text-danger small mt-1">*/}
      {/*                      {error.message}*/}
      {/*                    </div>*/}
      {/*                  )}*/}
      {/*                </Form.Group>*/}
      {/*              )}*/}
      {/*            />*/}

      {/*            <div className="d-grid">*/}
      {/*              <Button variant="primary" type="submit" disabled={isPending}>*/}
      {/*                {isPending && (*/}
      {/*                  <Spinner*/}
      {/*                    className="me-1"*/}
      {/*                    animation="border"*/}
      {/*                    size="sm"*/}
      {/*                    role="status"*/}
      {/*                  >*/}
      {/*                    <span className="visually-hidden">Loading...</span>*/}
      {/*                  </Spinner>*/}
      {/*                )}*/}
      {/*                Sign In*/}
      {/*              </Button>*/}
      {/*            </div>*/}
      {/*          </Form>*/}

      {/*          /!* <div className="text-center mt-3">*/}
      {/*            <a*/}
      {/*              href="/forgot-password"*/}
      {/*              className="text-decoration-none small"*/}
      {/*            >*/}
      {/*              Forgot password?*/}
      {/*            </a>*/}
      {/*          </div> *!/*/}
      {/*        </Card.Body>*/}
      {/*      </Card>*/}
      {/*    </Col>*/}
      {/*  </Row>*/}
      {/*</Container>*/}
    </>
  );
}
